import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import {
  ImmutableEntity,
  ParagraphEntity,
} from '@uncinc/react-drupal-core/types';

import './style.scss';

interface ParagraphProjectsFilteredProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphEntity>;
}

const ParagraphProjectsFiltered: React.FC<ParagraphProjectsFilteredProps> = () => (
  <div className="ParagraphProjectsFiltered">
    <View
      classes="row"
      id="projects_filtered"
      display="projects_filtered"
      withProvider
    />
  </div>
);

export default ParagraphProjectsFiltered;
